import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import ContactUs from './components/ContactUs';
import Blog from './components/Blog';
import FAQs from './components/FAQs';
import CabTours from './components/CabTours';
import TourPlanningTool from './components/tour-planner/TourPlanningTool';
import BurgerMenu from './components/BurgerMenu';
import './Styles.css';
import './App.css';
import BelfastPolitical from './components/tours/BelfastPolitical';
import MuralsTour from './components/tours/MuralsTour';
import GiantsCauseway from './components/tours/GiantsCauseway';
import DarkHedges from './components/tours/DarkHedges';
import Canonical from './components/Canonical';

function App() {
  return (
    <Router>
      <Canonical />
      <BurgerMenu />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cab-tours" element={<CabTours />} />
        <Route path="/tour-planning-tool" element={<TourPlanningTool />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/cab-tours/murals-tour" element={<MuralsTour />} />
        <Route path="/cab-tours/belfast-political" element={<BelfastPolitical />} />
        <Route path="/cab-tours/giants-causeway" element={<GiantsCauseway />} />
        <Route path="/cab-tours/dark-hedges" element={<DarkHedges />} /> 
      </Routes>
    </Router>
  );
}

export default App;
